import React from "react"; 

const Filosofia = () => {
  return (
    <section className="filosofia-container">
      <div className="filosofia-text">
      <h1>
  <span style={{ fontWeight: 1000 }}>NUESTRA</span> <br /> 
  <span style={{ fontWeight: 500 }}>FILOSOFÍA</span>
</h1>
        <p>
          No hacemos software por hacer<br></br> software.
          Creamos herramientas que<br></br> realmente
          funcionan, con un equipo<br></br> que piensa fuera de la caja.
        </p>
      </div>
      <div className="filosofia-mision-vision">
        <div className="mision">
          <h2>Misión</h2>
          <p> Crear software de alta calidad, fácil de usar y accesible para todos, brindando experiencias increíbles a través de soluciones tecnológicas que impacten positivamente en la vida de nuestros usuarios. Somos un equipo apasionado que cree en el poder del software para transformar negocios y personas. </p>
        </div>
        <div className="vision">
          <h2>Visión</h2>
          <p> Convertirnos en una empresa referente en el desarrollo de software en Latinoamérica, colaborando con empresas de diversos sectores mediante un equipo creativo y talentoso que innove constantemente. </p>
        </div>
      </div>
    </section>
  );
};

export default Filosofia;
